import {
  type PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useMemo,
  type FC,
} from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ComplianceLayerStore } from 'pages/settings/pages/compliance/store/complianceLayerStore'
import { useSettingsContext } from 'pages/settings/context/settingsContext'

const ComplianceLayerContext = createContext<ComplianceLayerStore | null>(null)

export const useComplianceLayerContext = () => {
  const context = useContext(ComplianceLayerContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ComplianceLayerProvider')

  return context
}

export const ComplianceLayerProvider: FC<PropsWithChildren> = ({ children }) => {
  const settingsContext = useSettingsContext()
  const entities = useEntitiesContext()
  const store = useMemo(
    () => new ComplianceLayerStore(settingsContext, entities),
    [settingsContext]
  )

  useEffect(() => store.dispose, [store])

  return <ComplianceLayerContext.Provider value={store}>{children}</ComplianceLayerContext.Provider>
}
